export const cosaOccorreList = [
  'La scuola in Italia è obbligatoria dai 6 ai 16 anni.',
  'La scuola statale italiana è pubblica e gratuita.',
  "L'anno scolastico si apre a settembre e chiude a giugno ma l'iscrizione può essere richiesta in qualsiasi periodo.",
  "Al momento dell'iscrizione la segreteria della scuola richiederà gli stessi documenti che vengono richiesti agli studenti italiani (anagrafici, scolastici e sanitari). In mancanza di tale documentazione, l'iscrizione verrà comunque accolta con riserva."
];
